import moment from "moment";
import {useContext, useMemo} from "react";
import DashboardParamsContext from "../context/DashboardParamsContext";
import {
    getFirstTechnologyGroupStart,
    getTechnologyGroupWeeks,
} from "../utils/SettingsUtils";
import {
    formatTechnoGroupName,
    getLastTechnologyGroupNames,
    getTechnologyGroupByTime,
} from "../utils/TechnologyGroupUtils";

export default function useFilterValueGroups(filterType, filterValue) {
    const [params] = useContext(DashboardParamsContext);

    const groups = useMemo(() => {
        if (filterType === "technologyGroup") {
            let groups = [];
            switch (filterValue.unit) {
                case "lastXClosed":
                    groups = getLastTechnologyGroupNames(
                        filterValue.group,
                        20,
                        {
                            technologyGroupStart:
                                getFirstTechnologyGroupStart(),
                            technologyGroupWeeks: getTechnologyGroupWeeks(),
                        }
                    );
                    break;
                case "lastGroups":
                    groups = getLastTechnologyGroupNames(filterValue.group, 0, {
                        technologyGroupStart: getFirstTechnologyGroupStart(),
                        technologyGroupWeeks: getTechnologyGroupWeeks(),
                    });
                    break;
                case "groupPicker":
                    groups = filterValue.group;
                    break;
                case "group":
                    groups = [filterValue.group];
                    break;
                case "week":
                    const {group} = filterValue;
                    const time = moment.utc().subtract(group, "weeks");
                    const technologyGroup = getTechnologyGroupByTime(
                        time,
                        getFirstTechnologyGroupStart(),
                        getTechnologyGroupWeeks()
                    );
                    groups = [
                        formatTechnoGroupName(
                            technologyGroup.start,
                            technologyGroup.end,
                            true
                        ),
                    ];
                    break;
                default:
                    console.warn("Nieznane grupowanie");
            }
            return groups;
        }
        if (filterType === "cycle") {
            let groups = [];
            switch (filterValue.unit) {
                case "cycle":
                    groups = [filterValue.value];
                    break;
                case "cycleRange":
                    groups = [
                        `${filterValue.value[0]}-${filterValue.value[1]}`,
                    ];
                    break;
                case "cycleGrouped":
                    groups = filterValue.value.map(
                        (row) => `${row[0]}-${row[1]}`
                    );
                    break;
                default:
                    console.warn("Nieznane grupowanie");
            }
            return groups;
        }
        switch (filterValue.unit) {
            case "finisherGroup":
                return [filterValue.group];
            case "groupPicker":
                return filterValue.group;
            case "lastInsertedGroups":
            case "lastClosedGroups":
                if (params) {
                    return params[0];
                }
                break;
            default:
                break;
        }
        return [];
    }, [filterType, filterValue, params]);

    return groups;
}
